// @flow

import React from 'react';
import { Text } from '../';
import InputWrapper from './InputWrapper';

type Props = {
  type: String,
  name: String,
  label: String,
  error: String | Object,
  value: String,
  className?: String,
  inputClassName: String,
  placeholder?: String,
  onChange: Function,
  element?: String,
  onBlur?: Function,
};

Input.defaultProps = {
  value: '',
  label: '',
  type: 'text',
  className: '',
  element: 'input',
  inputClassName: '',
  onChange: () => {},
  onBlur: () => {},
};

function Input({
  type,
  name,
  label,
  error,
  value,
  onBlur,
  element,
  onChange,
  className,
  placeholder,
  inputClassName,
}: Props) {
  return (
    <InputWrapper className={className}>
      {label ? (
        <>
          <Text
            type="label"
            htmlFor={name}
            className={`mb-1 w-100 ${error ? 'has-error' : ''}`}
          >
            {label}
          </Text>
          {error ? (
            <span className="px-1 font-xs text-red">- {error}</span>
          ) : null}
        </>
      ) : null}
      {element === 'input' ? (
        <input
          name={name}
          type={type}
          value={value || ''}
          onChange={onChange}
          placeholder={placeholder}
          className={`${inputClassName} ${error ? 'has-error' : ''}`}
          onBlur={onBlur}
        />
      ) : (
        <textarea
          name={name}
          type={type}
          value={value || ''}
          onChange={onChange}
          placeholder={placeholder}
          className={`${inputClassName} ${error ? 'has-error' : ''}`}
          onBlur={onBlur}
        />
      )}
    </InputWrapper>
  );
}

export default Input;
